import {
  IColumn,
  Panel,
  PanelType,
  Persona,
  PersonaInitialsColor,
  PersonaPresence,
  PersonaSize,
} from "@fluentui/react";
import React, { useCallback } from "react";
import { IEquipo, ISupervisores } from "../../../Interfaces/IListaVerificacion";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { useTableEquipoBySupervisor } from "../../../hooks/TablasHooks/useTableEquipoBySupervisor";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";
import { TagDefault } from "../../../components/indicadores/Tags";

interface IPanelEquipoTrabajoBySupervisor {
  isOpen: boolean;
  onDismiss: () => void;
  itemSelect: ISupervisores | undefined;
}

export const PanelEquipoTrabajoBySupervisor = (
  props: IPanelEquipoTrabajoBySupervisor
) => {
  const _columns: IColumn[] = [
    {
      key: "persona",
      name: "Persona",
      fieldName: "persona",
      minWidth: 500,
      maxWidth: 500,
      isResizable: true,
      isMultiline: true,
      onRender: (item: IEquipo) => (
        <Persona
          initialsColor={PersonaInitialsColor.coolGray}
          imageInitials={item.persona.substring(0, 1)}
          text={`${item.nroDOI} - ${item.persona}`}
          secondaryText={`${item.puesto}`}
          tertiaryText={`${item.empresa}`}
          size={PersonaSize.size24}
          showSecondaryText={true}
          styles={{ root: { color: "blue" } }}
          hidePersonaDetails={false}
        />
      ),
    },
  ];
  const _onRenderHeaderEquipoT = useCallback(
    () => (
      <div className="ms-Grid-col ms-sm12 ms-lg12">
        <Persona
          imageInitials={`${props.itemSelect?.persona.substring(0, 2)}`}
          initialsColor={PersonaInitialsColor.gray}
          text={`${props.itemSelect?.puesto}`}
          secondaryText={`${props.itemSelect?.persona}`}
          size={PersonaSize.size56}
          showSecondaryText={true}
          presence={PersonaPresence.online}
        />
      </div>
    ),
    [props.isOpen]
  );

  const { data, paginacion, isLoading, onChangeSkip } =
    useTableEquipoBySupervisor(props.itemSelect?.supervisorId);

  return (
    <>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderHeader={_onRenderHeaderEquipoT}
        // onRenderFooter={onRenderFooterPanel}
        isFooterAtBottom={true}
        isBlocking={false}
        closeButtonAriaLabel="Close"
        type={PanelType.medium}
        isLightDismiss
      >
        <div className="ms-Grid" dir="ltr">
          <br />
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <TagDefault
                bodyMenssaje={`${
                  paginacion?.total <= 0 ? "Sin personas" : "Supervisa"
                } ${paginacion?.total} Persona(s)`}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <TableBase2
                column={_columns}
                data={data}
                isLoading={isLoading}
                footerPagination={
                  <PaginationFooterC
                    paginacion={paginacion}
                    onChangePagina={(e) => {
                      onChangeSkip(e);
                    }}
                  />
                }
              />
            </div>
          </div>
        </div>
      </Panel>
    </>
  );
};
